import { Button } from "reactstrap";

interface Props {
  onOpenSettings: any;
  title?: string;
  description?: string;
}

const WidgetError = ({
  onOpenSettings,
  title = "No results were found.",
  description = "Check your chart settings, as they currently yield no result.",
}: Props) => {
  return (
    <div
      style={{ height: "calc(100% - 42px)" }}
      className="d-flex flex-column justify-content-center align-items-center"
    >
      <h4 className="font-weight-600">{title}</h4>
      <p className="text-center">
        <small>{description}</small>
      </p>
      {onOpenSettings && (
        <Button size="sm" outline color="primary" onClick={onOpenSettings}>
          Open Settings
        </Button>
      )}
    </div>
  );
};

export default WidgetError;
